import React, { useEffect, useState } from "react";
import HDRList, { HDRData } from "../../components/ohdr/HDRList";
import { errorMessage } from "../../utils/notificationUtils";
import { getHdrList } from "../../apis/nephroPlusService/OHDRService";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import { fetchAllSchemesOnBoard } from "../../models/schemeSlice";
import { useNavigate } from "react-router-dom";
import { Input, Typography } from "antd";
import { Skeleton } from "antd";
import ListFiltersContainer from "./ListFiltersContainer";
import dayjs from "dayjs";
import { Button } from "antd";
import DayClosureModal from "./DayClosureModal";
import ReportsModal from "./ReportsModal";
import ShiftClosureModal from "./ShiftClosureModal";
import { useMediaQuery } from "react-responsive";

const { Text, Title } = Typography;

const HDRListContainer: React.FC = () => {
  const [page, setPage] = useState(0);
  const pageSize = 100;
  const total = 50;

  const [selectedSchemeId, setSelectedSchemeId] = useState<string | null>(null);
  const { auth, hospital } = useSelector((state: RootState) => state);

  const dispatch = useDispatch<AppDispatch>();

  const [filters, setFilters] = useState({
    startDate: dayjs().format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
    searchTerm: "",
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 100,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["10", "20", "50", "100"],
  });

  const handleTableChange = (newPagination: any) => {
    fetchHDRList(newPagination.current, newPagination.pageSize);
  };

  useEffect(() => {
    const fetchSchemes = async () => {
      if (hospital?.selectedHospital?.value) {
        const response = await dispatch(
          fetchAllSchemesOnBoard({
            accessToken: auth.accessToken || "",
            healthCareId: hospital?.selectedHospital?.value,
          })
        );

        const ayushman = response?.payload?.find(
          (scheme: any) => scheme?.schemeMetaDataName === "Ayushman Bharat"
        );
        setSelectedSchemeId(ayushman?.schemeMetaDataId);
      }
    };

    fetchSchemes();
  }, [hospital?.selectedHospital?.value]);

  const [data, setData] = useState<any>([]);
  const [isFetchingList, setIsFetchingList] = useState<boolean>(false);

  const fetchHDRList = async (current: number, pageSize: number) => {
    try {
      setIsFetchingList(true);
      const res = await getHdrList(
        hospital?.selectedHospital?.value,
        selectedSchemeId,
        current,
        pageSize,
        filters.startDate,
        filters.endDate,
        filters.searchTerm
      );

      const updatedResponseData = res?.data?.content?.map((patient: any) => {
        return {
          id: patient?.visitId,
          ...patient,
          ...patient?.ohdrDetails,
        };
      });

      setPagination((prev) => ({
        ...prev,
        current: res?.data?.pageNumber + 1,
        pageSize: res?.data?.pageSize,
        total: res?.data?.totalElements,
      }));
      setData(updatedResponseData);
      setIsFetchingList(false);
    } catch (err: any) {
      errorMessage("Please, Try again later");
      setIsFetchingList(false);
    }
  };

  useEffect(() => {
    if (selectedSchemeId && hospital?.selectedHospital?.value)
      fetchHDRList(pagination.current, pagination.pageSize);
  }, [selectedSchemeId, hospital?.selectedHospital?.value, filters]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleFiltersChange = (newFilters: any) => {
    setFilters(newFilters);
  };

  const handleFillHDR = (id: string) => {
    // Handle fill HDR logic here
  };

  const handleSearch = (search: string) => {
    // Handle search logic here
  };

  const [showDayClosureModal, setShowDayClosureModal] = useState(false);
  const [showShiftClosureModal, setShowShiftClosureModal] = useState(false);
  const [showReportsModal, setShowReportsModal] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1024 });

  return (
    <div style={{ padding: isMobile ? 4 : isTablet ? 12 : 0 }}>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          justifyContent: "space-between",
          marginBottom: isMobile ? "10px" : "20px",
          alignItems: isMobile ? "flex-start" : "center",
          gap: isMobile ? 8 : 0,
        }}
      >
        <Title
          level={4}
          style={{
            marginBottom: isMobile ? 10 : 20,
            fontWeight: "bold",
            textTransform: "none",
          }}
        >
          oHDR
        </Title>
        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: isMobile ? "wrap" : "nowrap",
          }}
        >
          {hospital?.selectedHospital?.value !== -1 && (
            <>
              <Button
                type="default"
                style={{
                  marginRight: 8,
                  fontWeight: 400,
                  backgroundColor: "#d35d43",
                  borderColor: "#d35d43",
                  boxShadow: "0px -3px 4px 0px #00000040 inset",
                  color: "white",
                  width: isMobile ? "31%" : undefined,
                }}
                shape="round"
                onClick={() => setShowReportsModal(true)}
              >
                Reports
              </Button>
              <Button
                type="primary"
                style={{
                  backgroundColor: "#d35d43",
                  borderColor: "#d35d43",
                  boxShadow: "0px -3px 4px 0px #00000040 inset",
                  width: isMobile ? "31%" : undefined,
                }}
                shape="round"
                onClick={() => setShowDayClosureModal(true)}
              >
                Day Closure
              </Button>
              <Button
                type="primary"
                style={{
                  backgroundColor: "#d35d43",
                  borderColor: "#d35d43",
                  boxShadow: "0px -3px 4px 0px #00000040 inset",
                  width: isMobile ? "31%" : undefined,
                }}
                shape="round"
                onClick={() => setShowShiftClosureModal(true)}
              >
                Shift Closure
              </Button>
            </>
          )}
        </div>
      </div>
      <div
        style={{
          border: "0.4px solid #808184",
          padding: isMobile ? "8px" : "20px",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
        }}
      >
        <ListFiltersContainer
          handleFiltersChange={handleFiltersChange}
          // hideDateFilters={true}
        />
      </div>

      {isFetchingList ? (
        <Skeleton active paragraph={{ rows: 10 }} />
      ) : (
        <HDRList
          data={data}
          total={total}
          page={page}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onFillHDR={handleFillHDR}
          onSearch={handleSearch}
          pagination={pagination}
          handleTableChange={handleTableChange}
          fetchHDRList={fetchHDRList}
        />
      )}

      <DayClosureModal
        visible={showDayClosureModal}
        onCancel={() => setShowDayClosureModal(false)}
        hospitalId={hospital?.selectedHospital?.value}
        schemeId={selectedSchemeId}
        key={Date.now() + 1000}
      />

      <ShiftClosureModal
        visible={showShiftClosureModal}
        onCancel={() => setShowShiftClosureModal(false)}
        hospitalId={hospital?.selectedHospital?.value}
        schemeId={selectedSchemeId}
        key={Date.now()}
      />

      <ReportsModal
        visible={showReportsModal}
        onCancel={() => setShowReportsModal(false)}
        hospitalId={Number(hospital?.selectedHospital?.value) || 0}
        schemeId={Number(selectedSchemeId) || 0}
      />
    </div>
  );
};

export default HDRListContainer;
